import React from 'react';
import { Clock, LogOut } from 'lucide-react';

const IdleTimeoutModal = ({ countdown, onStayLoggedIn, onLogout }) => {
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
            <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full mx-4 text-center">
                <div className="mx-auto w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
                    <Clock className="w-8 h-8 text-amber-600" />
                </div>

                <h2 className="text-xl font-bold text-gray-900 mb-2">Session Expiring</h2>
                <p className="text-gray-600 mb-4">
                    You've been inactive for a while. Your session will expire in:
                </p>

                <div className="text-4xl font-bold text-amber-600 mb-6">
                    {countdown}<span className="text-lg font-normal text-gray-500 ml-1">s</span>
                </div>

                <div className="flex gap-3">
                    <button
                        onClick={onLogout}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium"
                    >
                        <LogOut className="w-4 h-4" />
                        Logout
                    </button>
                    <button
                        onClick={onStayLoggedIn}
                        className="flex-1 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-semibold"
                    >
                        Stay Logged In
                    </button>
                </div>
            </div>
        </div>
    );
};

export default IdleTimeoutModal;
